import React from "react";
import { pipe, replace, toLower } from "lodash/fp";
import { Roules } from "../utils/auth";
import { Route } from "react-router-dom";
import { HealthCheckStepCheckIn } from "../pages/agendas/components/health-check/step-checkin";
import { MainRegister } from "../pages/register-walk-in/main-register-walk-in";
import { MainAgendes } from "../pages/agendas/main-agendes";
import { MainYenDForm } from "../pages/agendas/main-yend";
import { EconnectStepLimitUser } from "../pages/agendas/components/econnect/step-limit-user";
import { EconnectStepFour } from "../pages/agendas/components/econnect/step-four";
import { EconnectStepCheckin } from "../pages/agendas/components/econnect/step-checkin";
import { EconnectStepWristband } from "../pages/agendas/components/econnect/step-wristband";
import { EconnectSelectSection } from "../pages/agendas/components/econnect/select-section";
import { EconnectDinner } from "../pages/agendas/components/econnect/dinner";
import { EconnectSuccessDinner } from "../pages/agendas/components/econnect/success-dinner";
import { EconnectSuccessSection } from "../pages/agendas/components/econnect/success-section";

type MenuConfig = {
  icon?: JSX.Element;
  label: string;
  component: JSX.Element;
  roles?: Roules[];
  path?: string;
  children?: MenuConfig[];
};

const menuConfigs: MenuConfig[] = [
  {
    icon: <></>,
    label: "register-form",
    path: "activity-step/:agendaid",
    component: (
      <>
        <Route index element={<MainAgendes />} />
        <Route path=":ticketid" element={<EconnectStepFour />} />
        <Route path=":typeregis/:customerid" element={<MainAgendes />} />
        <Route path="vip/:typeregis" element={<MainAgendes />} />
      </>
    ),
  },
  {
    icon: <></>,
    label: "แก้ใขแบบฟรอม",
    path: "check-in/:agendaid",
    component: (
      <>
        <Route path=":ticketid" element={<EconnectStepCheckin />} />
      </>
    ),
  },
  {
    icon: <></>,
    label: "wristband",
    path: "wristband/:agendaid",
    component: (
      <>
        <Route path=":wristbandid" element={<EconnectStepWristband />} />
      </>
    ),
  },
  {
    icon: <></>,
    label: "select-section",
    path: "select-section/:agendaid",
    component: (
      <>
        <Route path="success-dinner" element={<EconnectSuccessDinner />} />
        <Route path="success-section" element={<EconnectSuccessSection />} />
        <Route path=":ticketid" element={<EconnectSelectSection />} />
        <Route path="dinner/:ticketid" element={<EconnectDinner />} />
      </>
    ),
  },

  // {
  //   icon: <></>,
  //   label: "register-walk-in",
  //   path: "walkin-register/:agendaid",
  //   component: (
  //     <>
  //       <Route index element={<MainRegister />} />
  //     </>
  //   ),
  // },
  // {
  //   icon: <></>,
  //   label: "register-walk-in",
  //   path: "limit/:agendaid/:typeregis/:customerid",
  //   component: (
  //     <>
  //       <Route index element={<EconnectStepLimitUser />} />
  //     </>
  //   ),
  // },
];

export type MenuItem = MenuConfig & {
  path: string;
  key: string;
  children?: MenuItem[];
};

const menuItemMapper = (x: any): MenuItem => {
  const path = pipe(toLower, replace(" ", "-"))(x.path || x.label);
  return {
    ...x,
    key: path,
    path,
    ...(x.children?.length && {
      children: x.children.map(menuItemMapper),
    }),
  };
};

export const activitymenuItems = menuConfigs.map(menuItemMapper);
